import { useEffect } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { PopupStore } from '@gem/popups';

import Tasks from 'APP/Tasks';
import { useCloseFormPopup } from 'APP/main/PopupManager/hooks/useCloseFormPopup';

export function useCloseMediaMessageOnNavigation(popupInstance: PopupStore, groupId: string): void {
  const { t } = useTranslation();
  const closeForm = useCloseFormPopup(
    { popupInstance },
    t('cancel_channel_creation_alert'),
    (isClosed) => {
      if (!isClosed) {
        Tasks.group.setActiveGroup({ groupId });
      }
    }
  );

  useEffect(() => {
    closeForm.onFormStateChange({ pristine: false });
  }, []);
}
